/** @format */

import { Icon } from "@iconify/react";

const superAdminNav = [
  {
    id: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: <Icon icon='mdi:view-dashboard-outline' width='20' height='20' />,
  },
  {
    id: 1,
    path: "/company",
    title: "Companies",
    icon: <Icon icon='mdi:company' width='20' height='20' />,
  },

  {
    id: 3,
    title: "Manual Esign",
    path: "/manual-e-sign",
    icon: <Icon icon='uiw:file-pdf' width='20' height='20' />,
  },
  {
    id: 4,
    title: "Clients Report",
    icon: <Icon icon='gis:globe-users' width='20' height='20' />,
  },
];

const othersNavConfig = [
  {
    id: 2,
    title: "Users",
    path: "/user",
    icon: <Icon icon='mdi:users-group-outline' width='22' height='22' />,
  },
  {
    id: 2,
    title: "Trash",
    path: "/trash",
    icon: <Icon icon='ph:trash' width='23' height='23' />,
  },
];

const navConfig = [
  {
    id: 1,
    title: "Client Dashboard",
    path: "clientdashboard",
    icon: <Icon icon='mdi:view-dashboard-outline' width='20' height='20' />,
  },
  {
    id: 2,
    title: "Received",
    path: "/received",
    icon: <Icon icon='mdi:email-receive-outline' width='20' height='20' />,
  },
  {
    id: 3,
    title: "Sent",
    path: "/sent",
    icon: <Icon icon='mingcute:send-plane-line' width='20' height='20' />,
  },
  {
    id: 4,
    title: "Reports",
    path: "/reports",
    icon: <Icon icon='tabler:report' width='20' height='20' />,
  },
  {
    id: 5,
    title: "Credits",
    path: "/credits",
    icon: <Icon icon='mdi:credit-card-edit-outline' width='20' height='20' />,
  },
];

const navProfile = [
  {
    id: 1,
    title: "Profile",
    path: "/profile",
    icon: <Icon icon='iconoir:profile-circle' width='20' height='20' />,
  },
];
export { navConfig, navProfile, superAdminNav, othersNavConfig };
